var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rolling-number inline-block tabular-nums",class:{ 'rolling-number--pulse': _vm.pulse }},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }